import { useEffect } from 'react'
import { NVButton } from '@nv/basic-components'
import AudioIcon from '@nv/images/design/audio-icon'
import DocIcon from '@nv/images/design/doc-icon'
import PdfIcon from '@nv/images/design/pdf-icon'
import RemoveIcon from '@nv/images/design/remove-icon'
import VideoIcon from '@nv/images/design/video-icon'
import { useTranslation } from 'react-i18next'
import styles from './UploadedDocument.module.scss'

const UploadedDocument = ({ localFile, onChangeFile }) => {
  const { t } = useTranslation()

  const getFileType = (filename) => {
    const extension = filename.split('.').pop()
    return extension
  }

  useEffect(() => {
    //console.log('localFile', localFile)
  }, [localFile])

  return (
    <>
      <NVButton
        classes={{ container: styles['container'] }}
        variant='primaryGrey'
        text={t('uploads.changeDocument')}
        height={40}
        onClick={() => onChangeFile()}
        icon={<RemoveIcon />}
      />
      <div className={styles['upload__icon']}>
        {['jpg', 'jpeg', 'png'].includes(getFileType(localFile.name)) ? (
          <img src={URL.createObjectURL(localFile.file)} alt={localFile.name} className={styles['uploaded-image']} />
        ) : getFileType(localFile.name) === 'pdf' ? (
          <PdfIcon />
        ) : getFileType(localFile.name) === 'doc' || getFileType(localFile.name) === 'docx' ? (
          <DocIcon />
        ) : ['mov', 'mp4'].includes(getFileType(localFile.name)) ? (
          <VideoIcon />
        ) : ['mp3', 'wav'].includes(getFileType(localFile.name)) ? (
          <AudioIcon />
        ) : null}
      </div>
    </>
  )
}

export default UploadedDocument
